import { render } from "./AppTechnicalBody.vue?vue&type=template&id=5e229157"
import script from "./AppTechnicalBody.vue?vue&type=script&lang=js"
export * from "./AppTechnicalBody.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__